export default "__VITE_ASSET__BIVCV1bY__"